import { styled } from '@mui/material';

import { Typography } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

const PromoTextContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(5),
  position: 'relative',
  zIndex: 1,
  '@media(max-height: 500px)': {
    padding: `${theme.spacing(2)} ${theme.spacing(5)}`,
  },
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  lineHeight: '28px',
  marginBottom: theme.spacing(3),
  whiteSpace: 'pre-wrap',
  display: 'inline-block',
  '@media(max-height: 430px)': {
    display: 'none',
  },
  '@media(max-height: 500px)': {
    fontSize: 22,
  },
  '@media(max-height: 550px)': {
    marginBottom: theme.spacing(1.5),
  },
}));

const StyledLine = styled(Typography)({
  color: 'var(--text--text-secondary-color)',
  fontWeight: 400,
  fontSize: 14,
  lineHeight: '20px',
  '@media(max-height: 550px)': {
    fontSize: 12,
    lineHeight: '16px',
  },
});

const StyledList = styled('ul')({
  padding: 0,
  margin: 0,
  listStyleType: 'none',
  display: 'flex',
  flexDirection: 'column',
  gap: 5,
  '@media(max-height: 500px)': {
    display: 'none',
  },
});

export const PromoText = () => {
  const { t } = useI18n();

  return (
    <PromoTextContainer>
      <StyledTitle variant="header">{t('prototypes:slogan')}</StyledTitle>
      <StyledList>
        <li>
          <StyledLine>{t('prototypes:slogan_1')}</StyledLine>
        </li>
        <li>
          <StyledLine>{t('prototypes:slogan_2')}</StyledLine>
        </li>
        <li>
          <StyledLine>{t('prototypes:slogan_3')}</StyledLine>
        </li>
      </StyledList>
    </PromoTextContainer>
  );
};
